import styled from "@emotion/styled";

import { DesignToken, SpacingToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

const ToolbarSplit = styled.span<{ privateMode: boolean }>`
  display: inline-block;
  width: 1px;
  height: 16px;
  align-items: center;
  background-color: ${(props): string =>
    withVar(props.privateMode ? DesignToken.BorderInvertSecondary : DesignToken.BorderBasicSecondary)};
  margin: 0px ${withVar(SpacingToken.Spacing1)} 0 0px;
`;

export default ToolbarSplit;
